import 'babel-polyfill'
import 'url-search-params-polyfill'


import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueLazyload from 'vue-lazyload'
const loadimage = require('./assets/loading.gif')
const errorimage = require('./assets/error.gif')
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

Vue.config.productionTip = false 
// 引入过滤器
import  * as filters from '@/filters'
// 引入过滤器为全局
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])   
})
new Vue({
  	el: '#app',
  	router,
	store,
  	data: {
		eventHub: new Vue()
	},
  	render: h => h(App)
})

Vue.use(ElementUI);


// WEBPACK FOOTER //
// ./src/main.js